import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { LoginSource, SCREEN_SIZE } from '../../../classes/enums';
import { PageTitle } from '../../../classes/interfaces';
import { HasSubscriptions } from '../../has-subscriptions';
import { CommunicationService } from '../../../services/communication.service';
import { StaticPathPipe } from '../../../shared/pipes/static-path.pipe';

@Component({
  selector: 'app-promotional-overlay',
  templateUrl: './promotional-overlay.component.html',
  styleUrls: [
    './promotional-overlay.component.scss',
  ]
})
export class PromotionalOverlayComponent extends HasSubscriptions implements OnInit {

  PageTitleMap: Map<LoginSource, PageTitle> = new Map<LoginSource, PageTitle>([
    [LoginSource.Generic, {title: '', subtitle: ''}],
    [LoginSource.HomeEstimator,
      {title: this._translateService.instant('home-estimator.best-home-estimator'),
      subtitle: [this._translateService.instant('home-estimator.leading-estimator'), this._translateService.instant('home-estimator.estimates-are-for-free'), this._translateService.instant('home-estimator.contact-agent-for-valuation')]}
    ],
    [LoginSource.Radar,
      {title: this._translateService.instant('registration.join-remax-radar'),
      subtitle: [this._translateService.instant('registration.radar-customized-experience'), this._translateService.instant('registration.radar-receive-email'), this._translateService.instant('registration.radar-opt-out')]}
    ]
  ]);

  title: string;
  description: any;
  hideContent: boolean = false;
  LoginUsage = LoginSource;
  backgroundImage = {};
  screenSize: SCREEN_SIZE;
  @Input() sourcePage: LoginSource = LoginSource.Generic;

  constructor(
    private _translateService: TranslateService,
    private communicationService: CommunicationService,
    private staticPathPipe: StaticPathPipe,
  ) {
    super();
  }

  ngOnInit() {
    this.setPageTitle();
    this.addSub(this.communicationService.screenSize.subscribe((screenSize) => {
      this.screenSize = screenSize;
      this.hideContent = screenSize <= SCREEN_SIZE.MOBILE_ONLY && this.sourcePage === LoginSource.Generic ? true : false;
      this.backgroundImage = this.addStyle();
    }));
  }

  setPageTitle() {
    this.title = this.PageTitleMap.get(this.sourcePage).title;
    this.description = this.PageTitleMap.get(this.sourcePage).subtitle;
  }

  addStyle() {
    if (this.sourcePage === LoginSource.Radar) return this.addBackgroundImage('/assets/login/remax-radar.jpg');
    if (this.sourcePage === LoginSource.Generic) return this.addBackgroundImage('/assets/login/generic-promotional.jpg');
    if (this.screenSize >= SCREEN_SIZE.TABLET_LANDSCAPE_UP ) return this.addBackgroundImage('/assets/home-estimator/home-estimate-banner.jpg', 0.5);
    return this.addBackgroundImage('/assets/home-estimator/home-estimate-banner.jpg', 0.8);
  }

  addBackgroundImage(url: string, gradientValue: number = 0) {
    const statURL = this.staticPathPipe.transform(url +  '?auto=compress,format&q=0');
    if (gradientValue) {
      return {
        'background-image' : 'linear-gradient(45deg, rgba(0, 0, 0, ' + gradientValue + '), rgba(0, 0, 0, 0.0)),url(' + statURL + ')'
        };
    }
    else {
      return {
        'background-image' : 'url(' + statURL + ')'
      };
    }
  }

}



